<!-- Apple-style Ratings Widget -->
<div class="apple-card apple-ratings-widget" *ngIf="(averageRating$ | async) as avg">
  <!-- Header -->
  <div class="ratings-header">
    <mat-icon class="header-icon">star_rate</mat-icon>
    <h3 class="apple-heading-4">Kundenbewertungen</h3>
  </div>

  <!-- Rating Display -->
  <div class="ratings-content">
    <!-- Average Score -->
    <div class="rating-score-wrapper">
      <div class="rating-score" [ngClass]="getRatingColor(avg)">
        <span class="score-value">{{ avg | number:'1.1-1' }}</span>
        <span class="score-max">/5</span>
      </div>
      <p class="apple-caption rating-count">{{ ratingsCount$ | async }} Bewertungen</p>
    </div>

    <!-- Star Display -->
    <div class="rating-stars" [ngClass]="getRatingColor(avg)">
      <ng-container *ngFor="let star of stars; let i = index">
        <mat-icon class="star-icon">
          {{ i < Math.round(avg) ? 'star' : 'star_border' }}
        </mat-icon>
      </ng-container>
    </div>
  </div>

  <!-- Action Button -->
  <button
    class="apple-button apple-button-secondary"
    [routerLink]="['/admin/feedback']">
    <mat-icon>assessment</mat-icon>
    Feedback-Übersicht
  </button>
</div>
